export default "__VITE_ASSET__CNclivtC__"